import { GET_POLICY_TERMS } from '../../constants/actions/policy';

export function getPolicyTerms() {
    return {
        type: GET_POLICY_TERMS,
    };
}
